
/**
 * The object in charge of the tracking.
 *
 * This sets and retrieves cookies.
 *
 */
export default function Tracking(verbose) {
    this.nbHours = 2160; // 3*30 days
    this.cookieKey = 'predcwwk';
    this.identifier = null;
    this.verbose = verbose;
    this.TRACK_COOKIE_NAME = 'p_notifications';
    this.trackHours = 2;
}

/**
 * Looks up for a cookie, if any already exists. If no cookie is to be found,
 * sets a new one and returns its value.
 *
 * @return {string} the identifier.
 */
Tracking.prototype.getIdentifier = function() {
    if (this.identifier) {
        return this.identifier;
    }

    this.identifier = this.getCookie(this.cookieKey);
    if (this.verbose) {
        console.log('Retrieved identifier ' + this.identifier);
    }
    if (this.identifier) {
        return this.identifier;
    }

    this.identifier = this._generateUUID();
    this.setCookie(this.cookieKey, this.identifier, this.nbHours);

    return this.identifier;
};

/**
 * Generates a unique identifier, using the cryptographic generator,
 * if it is available.
 *
 * @return {string} a unique identifier.
 */
Tracking.prototype._generateUUID = function() {

    if (typeof(window.crypto) != 'undefined' && typeof(window.crypto.getRandomValues) != 'undefined') {
        // If we have a cryptographically secure PRNG, use that
        // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
        var buf = new Uint16Array(8);
        window.crypto.getRandomValues(buf);
        var S4 = function (num) {
            var ret = num.toString(16);
            while (ret.length < 4) {
                ret = '0' + ret;
            }
            return ret;
        };

        return S4(buf[0]) + S4(buf[1]) + '-' + S4(buf[2]) + '-' + S4(buf[3]) + '-' + S4(buf[4]) + '-' + S4(buf[5]) + S4(buf[6]) + S4(buf[7]);

    } else {
        // Otherwise, just use Math.random
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

};

/**
 * Sets a new cookie into the browser.
 *
 * @param {string} cookieValue The value of the cookie.
 * @return {string} the value of the cookie.
 */
Tracking.prototype.setCookie = function(cookieKey, cookieValue, nbHours) {
    var date = new Date();
    date.setTime(date.getTime() + (nbHours * 60 * 60 * 1000));
    var expires = 'expires=' + date.toUTCString();
    var cookie = cookieKey + '=' + encodeURIComponent(cookieValue) + '; ' + expires + '; path=/';
    document.cookie = cookie;
    if (this.verbose) {
        console.log('Set cookie ' + cookie);
    }
    return cookieValue;
};

/**
 * Looks for a cookie. If none is to be found,
 * returns null.
 *
 * @return {string} the value of the cookie, or
 * null if none exists.
 */
Tracking.prototype.getCookie = function(cookieKey) {
    var name = cookieKey + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var currentCookie = cookies[i];
        while (currentCookie.charAt(0) == ' ') {
            currentCookie = currentCookie.substring(1);
        }
        if (currentCookie.indexOf(name) == 0) {
            var rawValue = currentCookie.substring(name.length, currentCookie.length);
            return decodeURIComponent(rawValue);
        }
    }
    return null;
};

/**
 * Retrieves the tracking queue from the
 * cookies.
 *
 * The return value may be empty.
 *
 * @return {[string]} the tracking-codes previously
 * stored in a cookie.
 */
Tracking.prototype.getNotifQueue = function() {

    var cookieValue = this.getCookie(this.TRACK_COOKIE_NAME);

    if (! cookieValue) {
        return [];
    }

    try {
        return JSON.parse(cookieValue);
    } catch (ex) {
        if (this.verbose) {
            console.log('Exception in getNotifQueue() ' + ex);
        }
        return [];
    }
};

/**
 * Stores a tracking code in a cookie.
 *
 * @param {string} trackingCode The tracking-code.
 */
Tracking.prototype.storeNotif = function(trackingCode) {

    var currentValues = this.getNotifQueue();

    if(currentValues.indexOf(trackingCode) > -1) {
        return;
    }

    currentValues.push(trackingCode);

    this.setCookie(this.TRACK_COOKIE_NAME, JSON.stringify(currentValues), this.trackHours);
};

/**
 * Removes a tracking code from the storing cookie.
 *
 * @param {string} trackingCode The tracking-code.
 */
Tracking.prototype.removeNotif = function(trackingCode) {

    var currentValues = this.getNotifQueue();

    var index = currentValues.indexOf(trackingCode);
    if (index > -1) {
        currentValues.splice(index, 1);
    }

    this.setCookie(this.TRACK_COOKIE_NAME, JSON.stringify(currentValues), this.trackHours);
};


